import { render, staticRenderFns } from "./BusinessPageAccess.vue?vue&type=template&id=55e0ed14&scoped=true&"
import script from "./BusinessPageAccess.vue?vue&type=script&lang=ts&"
export * from "./BusinessPageAccess.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessPageAccess.vue?vue&type=style&index=0&id=55e0ed14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e0ed14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBtn,VCol,VForm,VRow,VSheet,VSpacer,VTextField,VToolbarTitle})
